import { render, staticRenderFns } from "./SocialMedia.v2.vue?vue&type=template&id=8849d97e&scoped=true&"
import script from "./SocialMedia.v2.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.v2.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedia.v2.vue?vue&type=style&index=0&id=8849d97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8849d97e",
  null
  
)

export default component.exports